export default __webpack_public_path__ + "images/pictograms/dropzone.svg?d6b3864a5acbb6e66e436cde055a5677c744a3c90cc90e26230c542f0be4be15";